import { Routes, Route } from "react-router-dom";

import Home from "../pages/Home";
import SalesAgent from "../pages/agents/SalesAgent";

function AppRoute() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />

      <Route
        path="/agents/sales"
        element={<SalesAgent />}
      />
    </Routes>
  );
}

export default AppRoute;